var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHouseSimple = function SvgIconHouseSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.82 2.72a1.75 1.75 0 0 1 2.361.002l7.498 6.813-.673.74.687-.727a1.78 1.78 0 0 1 .557 1.264V19.5a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-8.688a1.78 1.78 0 0 1 .557-1.264l.014-.013 7.498-6.813zm8.43 8.219L12 4.35l-7.25 6.588v8.311h14.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHouseSimple;